<template>
  <v-container>

    <Titulo></Titulo>

    <div style="width: 93%; margin: auto;">
    <NavBar :step="0" />
    <br>

    <v-row  v-if="screen > 800" style="margin: auto; margin-top: -5%;">
      <img :src="casita" alt="Image c" class="casita-img">
      <img :src="banner" alt="Image b" class="banner-img">
    </v-row>

    <v-col v-if="screen < 800" style="margin-top: -27%; margin-bottom: -2%;">
      <img :src="bannerMobile" alt="Image b" class="banner-img-mobile" >
      <img :src="casitaMobile" alt="Image c" class="under-banner-mobile">
      <v-col>
      </v-col>
    </v-col>

    <br v-if=" screen > 800">

    <v-stepper v-model="e1" elevation="0">

      <v-stepper-header>
        <div class="circle-step">
          <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 1" step="1"> Inicio
          </v-stepper-step>
        </div>
        <v-divider></v-divider>
        <div class="circle-step2">
          <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 2" step="2"> Plan
          </v-stepper-step>
        </div>
        <v-divider></v-divider>
        <div class="circle-step2">
          <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 4" step="4"> DPS
          </v-stepper-step>
        </div>
        <v-divider></v-divider>
        <div class="circle-step2">
          <v-stepper-step style="flex-direction: column;" :color="stepperColor" step="5"> Datos </v-stepper-step>
        </div>
      </v-stepper-header>

      <br v-if="screen > 800">
      <br v-if="screen > 800">

      <v-stepper-items>
        <v-stepper-content step="1">
          <div :class="formText">

            <v-form ref="form" v-model="valid" max-witdh="300px">

              <h3 class="text-center labelHola">¡Hola! ¿Cómo te llamas?</h3>

              <!-- <h3 class="text-center labelQuestion">¿Cómo te llamas?</h3> -->
              <br>
              <p class="titleLabel">Nombre </p>
              <v-text-field class="labelNombre" v-model="userData.name" :rules="nameRules" label="Nombre" required
                maxlength="51" filled solo @change="change()"></v-text-field>
        
              <br>
              <br>
              <p class="titleLabel">Apellido </p>
              <v-text-field class="labelNombre" v-model="userData.surname" @change="change()" :rules="surnameRules"
                maxlength="51" label="Apellido" required filled solo></v-text-field>
      
           
              <br>
              <br>

              <h3 class="text-center labelQuestion">¿Cuál es tu edad?</h3>

              <h4 class="text-center labelSubQuestion">Es para recomendarte el mejor seguro.</h4>
              <p class="titleLabel">Edad </p>
              <div style="display: flex; justify-content: center; align-items: center;">
             
              <v-select class="labelNombre" :rules="oldRules" :items="years"
                v-model="userData.old" :loading="loadingYears" item-text="name" label="Selecciona tu edad" return-object required
                filled solo>
              </v-select>

              </div>

              <!-- <v-row v-if="screen < 800">

                <v-col>
                  <v-select class="labelDatesMovil" style="max-width: 90px; height: 48px;" :rules="monthRules"
                    :items="months" v-model="month" :loading="loadingMonths" v-on:change="getDays()" item-text="name"
                    label="Mes" return-object required filled solo></v-select>
                </v-col>

                <v-col>
                  <v-select class="labelDatesMovil" style="max-width: 90px; height: 48px;" :rules="dayRules"
                    :items="days" v-model="day" :loading="loadingDays" :disabled="loadingDays || month === null"
                    item-text="name" label="Día" return-object required filled solo>
                  </v-select>
                </v-col>

                <v-col>
                  <v-select class="labelDatesMovil" style="max-width: 90px; height: 48px;" :rules="yearRules"
                    value="2022" :items="years" v-model="year" item-text="name" label="Año" return-object required
                    filled solo></v-select>
                </v-col>

              </v-row>

              <v-row v-else>

                <v-col>
                  <v-select class="labelDatesdesktop" style="max-width: 160px; height: 48px;" :rules="monthRules"
                    :items="months" v-model="month" :loading="loadingMonths" v-on:change="getDays()" item-text="name"
                    label="Mes" return-object required filled solo></v-select>
                </v-col>

                <v-col>
                  <v-select class="labelDatesdesktop" style="max-width: 160px; height: 48px;" :rules="dayRules"
                    :items="days" v-model="day" :loading="loadingDays" :disabled="loadingDays || month === null"
                    item-text="name" label="Día" return-object required filled solo>
                  </v-select>
                </v-col>

                <v-col>
                  <v-select class="labelDatesdesktop" style="max-width: 160px; height: 48px;" :rules="yearRules"
                    value="2022" :items="years" v-model="year" item-text="name" label="Año" return-object required
                    filled solo></v-select>
                </v-col>

              </v-row> -->

              <br>
              <br>
           
              <h3 class="text-center labelQuestion">¿Cuál es tu email?</h3>

              <h4 class="text-center labelSubQuestion">Aquí enviaremos tu póliza de seguro.
              </h4>
              <p class="titleLabel">Email </p>
              <v-text-field class="labelEmail" v-model="userData.email" @change="change()" maxlength="51"
                :rules="emailRules" label="Escribe tu email" filled solo></v-text-field>

              <br v-if=" screen < 800">
              
              <!-- <h3 class="text-center labelQuestion">¿Cuál es tu sistema de Salud?</h3>

              <h4 class="text-center labelSubQuestion">Esto nos ayuda a recomendarte el mejor plan disponible para
                protegerte</h4>

              <v-col>
                <v-radio-group :rules="ssRules" v-model="userData.salud" row>
                  <div class="radio-group">
                    <v-radio style="font-size: 40px;" label="ISAPRE" value="Isapre" @change="change()">
                      <label class="labelSalud">Isapre</label>
                    </v-radio>
                    <v-radio style="font-size: 40px;" label="FONASA*" value="Fonasa" @change="change()">
                      <label class="labelSalud">Fonasa*</label>
                    </v-radio>
                  </div>
                </v-radio-group>
              </v-col>

              <h4 class="text-center labelSubQuestion">*No incluye FONASA “A” y PRAIS.</h4> -->

              <div class="formData">
                <v-row justify="center">
                  <v-dialog v-model="dialog" width="600px">
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">Términos y Condiciones</span>
                      </v-card-title>
                      <v-card-text style="text-align: justify;">
                        Al aceptar estos términos, autorizo expresamente a Southbridge Compañía de Seguros Generales S.A. para que trate, almacene, transmita y comunique mis datos personales y la información que he proporcionado voluntariamente, conforme a las finalidades y condiciones que se detallan a continuación:
                        <br><br>
                        <span class="blackLetter">1. Finalidades del Tratamiento de Datos:</span>
                        <br><span class="blackLetter2">Ofrecimiento de Productos y Servicios:</span> Para que Southbridge y las entidades relacionadas me contacten y me proporcionen información y ofertas de sus productos y servicios.
                        <br><span class="blackLetter2">Ejecución del Contrato de Seguro:</span> Para gestionar y cumplir con las obligaciones derivadas del contrato de seguro.
                        <br><span class="blackLetter2">Implementación de Convenios Asociados:</span> Para hacer efectivos los convenios relacionados con los seguros que he contratado.
                        <br><br>  
                        <span class="blackLetter">2. Comunicación de Datos a Terceros:</span>
                        <br>-Autorizo la comunicación de mis datos personales a la empresa matriz de Southbridge, sociedades del grupo empresarial al que pertenece y terceros prestadores de servicios, ubicados dentro o fuera de Chile, exclusivamente para las finalidades antes mencionadas.
                        <br>
                        <br>-Southbridge garantiza que dichos terceros cumplirán con las mismas obligaciones de confidencialidad y seguridad en el tratamiento de mis datos personales.
                        <br><br>
                        <span class="blackLetter">3. Derechos del Titular de los Datos:</span>
                        <br>-Tengo derecho a acceder, rectificar, cancelar y oponerme al tratamiento de mis datos personales, conforme a lo establecido en la Ley N° 21.719.
                        <br>
                        <br>-Puedo revocar esta autorización en cualquier momento, lo que no afectará la licitud del tratamiento basado en el consentimiento previo a su retirada.
                        <br><br>
                        <span class="blackLetter">4. Medios de Comunicación:</span>
                        <br>- Acepto que cualquier información, comunicación, declaración o notificación que deba efectuar Southbridge en virtud del presente contrato de seguros sea realizada a través de correo electrónico u otros sistemas de transmisión o registro digital, garantizando la autenticidad e integridad de las comunicaciones.
                        <br><br>
                        <span class="blackLetter">5. Responsabilidad sobre Credenciales de Acceso:</span>
                        <br>-Reconozco que cualquier transacción realizada en el sitio <a href="https://southbridgeseguros.cl/" target="_blank" rel="noopener noreferrer">www.southbridgeseguros.cl</a> con mi RUT y clave personal se entenderá como realizada por mí.
                        <br>
                        <br>-Soy responsable del uso y seguridad de mi clave personal, y exonero a Southbridge de cualquier responsabilidad por el uso indebido de la misma por parte de terceros.
                        <br><br>
                        <span class="blackLetter">6. Veracidad de la Información:</span>
                        <br>-Me comprometo a proporcionar información veraz y actualizada para la contratación del seguro y el uso de las claves o códigos de acceso, liberando a Southbridge de responsabilidad por cualquier mal uso que terceros hagan de la información entregada exclusivamente a mi persona.
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          style="box-sizing: border-box; padding: 12px 24px; gap: 10px; background: #4F74E3; border: 2px solid #4F74E3;
                                  border-radius: 8px; margin-top: -6%; font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 14px; line-height: 17px;
                                  letter-spacing: 0.02em; color: white; flex: none; order: 0; flex-grow: 0; margin:auto;"
                          elevation="0" text @click="dialog = false">
                          Aceptar
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>


                <v-hover v-if="screen > 800">
                  <v-checkbox :rules="conditionsRules" :color="stepperColor" required>
                    <template v-slot:label>
                      <p
                        style="font-family: Helvetica; font-style: normal; font-weight: 400; font-size: 12px; line-height: 143.34%; letter-spacing: -0.3px; color: #232323; opacity: 0.8; text-align: justify; max-width: 400px; margin-top: 10%;">
                        Al ingresar tus datos y hacer clic en continuar aceptas que tu información sea utilizada 
                        para calcular tu estimación de prima de acuerdo a nuestros 
                        <b><a style="color:#3333CC" @click="dialog = true">Términos y
                            Condiciones</a></b></p>
                    </template>
                  </v-checkbox>
                </v-hover>

                <v-hover v-else>
                  <v-checkbox :rules="conditionsRules" :color="stepperColor" required>
                    <template v-slot:label>
                      <p
                        style="font-family: Helvetica; font-style: normal; font-weight: 400; font-size: 12px; line-height: 143.34%; letter-spacing: -0.3px; color: #232323; opacity: 0.8; text-align: justify; margin-top: 8%;">
                        Al ingresar tus datos y hacer clic en continuar aceptas que tu información sea utilizada 
                        para calcular tu estimación de prima de acuerdo a nuestros
                         <b><a style="color:#3333CC" @click="dialog = true">Términos y
                            Condiciones</a></b></p>
                    </template>
                  </v-checkbox>
                </v-hover>

                <v-hover v-if="screen > 800" style="margin-top: -11%;">
                  <v-checkbox :color="stepperColor"  >
                    <template v-slot:label>
                      <p style="font-family: Helvetica; margin-top: 5%; font-style: normal; font-weight: 400; font-size: 12px; line-height: 143.34%; letter-spacing: -0.3px; color: #232323; opacity: 0.8; text-align: justify; max-width: 400px;">
                        <span style="font-weight: bold;">¡Mantente informado!</span> Autoriza recibir emails con descuentos y beneficios exclusivos sobre tu seguro.</p>
                    </template>
                  </v-checkbox>
                </v-hover>
                
                <v-hover v-else style="margin-top: -6%;">
                  <v-checkbox :color="stepperColor" class="custom-checkbox">
                    <template v-slot:label>
                      <p class="custom-label">
                        <span style="font-weight: bold;">¡Mantente informado!</span> Autoriza recibir emails con descuentos y beneficios exclusivos sobre tu seguro.
                      </p>
                    </template>
                  </v-checkbox>
                </v-hover>

              </div>

              <div class="button-container">
                <v-btn class="button-desing"
                  @click="validate()">
                  Continuar
                </v-btn>
              </div>
            </v-form>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
  </v-container>
</template>

<script>
// import dateService from "@/services/date.service.js";
// import yearService from "@/services/year.service.js";
import oldService from "@/services/age-list.service.js";
import Titulo from "../components/Titulo.vue";
import NavBar from "@/components/NavBar.vue";

import logoFairfax from '@/assets/images/LogoFairfax.png';
// import banner from "@/assets/images/Banner.png";
// import vector from "@/assets/images/vector.png";

import banner from "@/assets/images/Banner.svg";
import bannerMobile from "@/assets/images/BannerMobile.svg";
import casita from "@/assets/images/casita.svg";
import casitaMobile from "@/assets/images/casitaMobile.svg";

// import swal from 'sweetalert';
// const moment = require('moment');
import CryptoJS from 'crypto-js';

import Vue from "vue";
import { VueReCaptcha } from 'vue-recaptcha-v3'

import ShieldService from "../services/shield.service";

const { VUE_APP_RECAPTCHA3_SITE_KEY } = process.env;

Vue.use(VueReCaptcha, { siteKey: VUE_APP_RECAPTCHA3_SITE_KEY })

export default {
  name: "Step1",
  components: { Titulo, NavBar },
  data: () => ({
    secretKey: process.env.VUE_APP_CRYPT,
    banner,
    bannerMobile,
    casita,
    casitaMobile,
    // vector,
    logoFairfax,
    formText: '',
    bannerImg: '',
    bannerContainer: '',
    stepperColor: '#4F74E3',
    userData: {
      name: null,
      surname: null,
      serialNumber: null,
      rut: null,
      typeIsapre: null,
      region: null,
      commune: null,
      comuneCode: null,
      regionCode: null,
      address: null,
      email: null,
      phoneNumber: null,
      couponId: null,
      stepId: null,
      old: null,
      dates: null,
      salud: null,
      questionOne: null,
      questionTwo: null,
      questionThree: null,
      typePlan: null,
      addressNumber: null,
      addressDepto: null,
      sonExist: false,
      arrayTypesBenef: [],
      oldAux: null,
      day: null,
      month: null,
      year: null,
    },
    servicesData: {
      stepId: null,
      contactID: null,
      type: 'create',
    },
    years: false,
    dialog: false,
    screen: window.screen.width,
    // months: [],
    // days: ["Selecciona el mes"],
    // yars: [],
    valid: false,
    activeCampaingUse: process.env.VUE_APP_ACTIVE_CAMPAIGN ? process.env.VUE_APP_ACTIVE_CAMPAIGN : 'FALSE',
    nameRules: [
      (v) => !!v || "El nombre es requerido",
      (v) => /^[a-zA-ZáéíóúüÜñÑ\s-]+$/.test(v) || "Ingrese solo letras",
      (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 caracteres"
    ],
    surnameRules: [
      (v) => !!v || "El apellido es requerido",
      (v) => /^[a-zA-ZáéíóúüÜñÑ\s-]+$/.test(v) || "Ingrese solo letras",
      (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 caracteres"
    ],
    ssRules: [(v) => !!v || "Seleccione sistema de Salud"],
    // monthRules: [
    //   (v) => !!v || "El mes es requerido",
    // ],
    // dayRules: [
    //   (v) => !!v || "El día es requerido",
    // ],
    // yearRules: [
    //   (v) => !!v || "El año es requerido",
    // ],
    oldRules: [
      (v) => !!v || "La edad es requerida",
    ],
    // saludRules: [(v) => !!v || "Seleccione una opción"],
    emailRules: [
      // Comentar la regla que hace obligatorio el correo
      // (v) => !!v || "El correo electrónico es requerido",
      (v) => !v || /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/.test(v) || "Ingrese un correo válido",
      (v) => !v || v.length <= 50 || "Debe ingresar máximo 50 caracteres"
    ],
    conditionsRules: [
      (v) => !!v || "Debe estar de acuerdo con los términos y condiciones",
    ],

  }),
  async mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;

    const query = this.$route.query;
    const userDataAux = sessionStorage.getItem('userData');
    const servicesDataAux = sessionStorage.getItem('servicesData');

    if (query.stepID) {
      const abandoned = await ShieldService.newGetStepAbandoned(query.stepID);

      this.userData = abandoned.userData;
      this.servicesData.stepId = abandoned._id;
      this.servicesData.type = 'update';

      const userDataLocal = JSON.stringify(this.userData);
      const servicesDataLocal = JSON.stringify(this.servicesData);

      const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
      const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();

      sessionStorage.setItem('userData', encryptedUserDataLocal);
      sessionStorage.setItem('servicesData', encryptedServicesDataLocal);

    } else if (userDataAux) {
      const bytesUserData = CryptoJS.AES.decrypt(userDataAux, this.secretKey);
      const decryptedDataUser = bytesUserData.toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(decryptedDataUser);
      // console.log("userData: ", this.userData);

      if (servicesDataAux) {
        const bytesServicesData = CryptoJS.AES.decrypt(servicesDataAux, this.secretKey);
        const decryptedServicesData = bytesServicesData.toString(CryptoJS.enc.Utf8);
        this.servicesData = JSON.parse(decryptedServicesData);
        // console.log("serivcesData: ", this.servicesData);
      }

    } else {
      const userDataLocal = JSON.stringify(this.userData);
      const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
      sessionStorage.setItem('userData', encryptedUserDataLocal);
    }

    this.getOld();

    if (this.screen > 800) {
      this.formText = 'formData';
      this.bannerImg = 'banner-img';
      this.bannerContainer = 'bannerContainer';
    } else {
      this.formText = '';
      this.bannerImg = 'banner-imgMobile';
      this.bannerContainer = 'bannerContainerMobile';
    }

  },
  methods: {
    async validate() {
      if (this.$refs.form.validate()) {

        // const fechaActual = new moment(new Date());
        // var newDate = this.year.id + "-" + this.month.number + "-" + this.day.id
        // var dateNacimiento = moment(new Date(newDate));
        // var timesDiff = fechaActual.diff(dateNacimiento, 'years');
        // if (timesDiff < 18) {
        //   swal({
        //     title: "Atención!",
        //     text: "Para contratar este seguro, usted debe ser mayor de edad!",
        //     icon: "info",
        //     button: "De acuerdo",
        //   });
        // } else if (timesDiff > 79) {
        //   swal({
        //     title: "Atención!",
        //     text: "Para contratar este seguro, usted debe ser menor a 79 años!",
        //     icon: "info",
        //     button: "De acuerdo",
        //   });
        // } else {
        // this.userData.dates = newDate;
        // this.userData.old = timesDiff;

        this.change();

        const userDataLocal = JSON.stringify(this.userData);
        const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
        sessionStorage.setItem('userData', encryptedUserDataLocal);

        var shieldRes;
        if (this.userData.email && this.activeCampaingUse == 'TRUE') {
          const activeCampaingRes = await ShieldService.getContactActiveCampain(this.userData.email);

          if (activeCampaingRes.data.data.meta.total == 1) {
            this.servicesData.contactID = activeCampaingRes.data.data.contacts[0].id;
            await ShieldService.updateContactActiveCampain(this.userData, null, this.servicesData, 0);
          } else {
            shieldRes = await ShieldService.createContactActiveCampain(this.userData, this.servicesData);

            if (shieldRes.data.status == 'ok') {
              this.servicesData.contactID = shieldRes.data.data.contacts[0].id;
            }
          }

          const servicesDataLocal = JSON.stringify(this.servicesData);
          const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
          sessionStorage.setItem('servicesData', encryptedServicesDataLocal);

        }

        this.$router.push({ path: '/og/planes' })
      }

      // }
    },
    // async getMonths() {
    //   this.loadingMonths = true;
    //   this.months = await dateService.getMonths();
    //   this.loadingMonths = false;
    // },
    // async getDays() {
    //   if (this.month) {
    //     this.loadingDays = true;
    //     this.day = null;
    //     this.days = await dateService.getDays(
    //       this.month.name
    //     );
    //     this.loadingDays = false;

    //   }
    // },
    // async getYears() {
    //   this.loadingYears = true;
    //   this.years = await yearService.getYears();
    //   this.loadingYears = false;
    // },
    async getOld() {
      this.loadingYears = true;
      this.years = await oldService.getAgeList();
      this.loadingYears = false;
    },
    async change() {
      // reCaptcha v3 token
      await this.$recaptchaLoaded();
      const tokenStep = await this.$recaptcha('captchaToken');

      try {

        const servicesDataAux = sessionStorage.getItem('servicesData');

        if (servicesDataAux) {
          const bytesServicesData = CryptoJS.AES.decrypt(servicesDataAux, this.secretKey);
          const decryptedServicesData = bytesServicesData.toString(CryptoJS.enc.Utf8);
          this.servicesData = JSON.parse(decryptedServicesData);
          // console.log("serivcesData: ", this.servicesData);
        }

        var carro = await ShieldService.newCreateStep(this.userData, null, null, this.servicesData, 'Inicio' , tokenStep);
        this.servicesData.type = 'update';
        this.servicesData.stepId = carro.data.data._id;

        const servicesDataLocal = JSON.stringify(this.servicesData);
        const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
        sessionStorage.setItem('servicesData', encryptedServicesDataLocal);

      } catch (error) {
        console.log("Cart Fail");
      }
    }
  },
};
</script>

<style lang="scss">
.html body div#app.v-application.v-application--is-ltr.theme--light div.v-application--wrap main.v-main div.v-main__wrap div.container div div.v-stepper.v-sheet.theme--light.elevation-0 div.v-stepper__items div.v-stepper__content div.v-stepper__wrapper div form.v-form div.formData div.v-input.v-input--has-state.theme--light.v-input--selection-controls.v-input--checkbox.error--text div.v-input__control div.v-messages.theme--light.error--text div.v-messages__wrapper div.v-messages__message {
  padding-bottom: 1% !important;
  text-align: center;
}

.v-messages__message {
  padding-bottom: 1% !important;
  text-align: center;
  margin: auto;
}

.button-desing {
  background-color: #2A3881 !important;
  color: white !important;
  border-radius: 40px !important;
  width: 231px !important; 
  height: 40px !important;
}

.labelHola {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 26px;
  letter-spacing: -0.01em;
  color: #2D387C;
  mix-blend-mode: darken;
}

.labelNombre {
  box-sizing: border-box;
  height: 57px;
  background: #FFFFFF;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
  margin: auto;
  border-radius: 6px;
}

.labelQuestion {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 15px;
  letter-spacing: -0.01em;
  color: #2D387C;
}

.labelSubQuestion {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  padding: 2%;
}

.labelEmail {
  box-sizing: border-box;
  height: 57px;
  margin: auto;
  background: #FFFFFF;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
  border-radius: 6px;
}

.labelEdad {
  max-width: 163px;
  height: 57px;
  background: #FFFFFF;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
  border-radius: 6px;
}

.labelSalud {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 16px;
  color: #2D387C;
  opacity: 0.75;
  mix-blend-mode: normal;
  height: 16px;
}

.step-date {
  max-width: 200px;
  align-items: center;
  display: flex;
  margin-left: 2rem;
  justify-content: center;

  .v-select {
    max-width: 150px;
  }
}

.labelDatesMovil {
  background: #FFFFFF;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
  border-radius: 6px;
}

.labelDatesdesktop {
  background: #FFFFFF;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
  border-radius: 6px;
  min-height: 57px;
}

.v-input .v-label {
  font-size: 12px;
  color: #8E8E8E;
}

.formData {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.v-messages__message {
  padding-bottom: 10%;
  text-align: center;
}

.v-btn__content {
  padding: 0.75rem;
}


.radio-group{
  display: flex; 
  margin: auto; 
  padding-left: 40%;
}

@media (max-width: 600px){
  .radio-group{
  display: flex; 
  margin: auto; 
  padding-left: 30%;
}
}

// _________________________________________________
// _________________________________________________

.first-col{
  // margin-left: 14%; 
  margin-top: -6%;
}

.second-row{
  text-align: center; 
  align-items: center; 
  justify-content: flex-start;
}

.banner-img{
  width: 150%;
  height: 200px;
  // margin-left: 40%;
  margin-bottom: 3%;
  // margin-right: 14%;
  margin-left: 49%; 
  margin-top: -15%;
}

@media (min-width: 1920px){
  .banner-img{
    width: 100%;
    // margin-left: 40%;
    margin-left: 30%;
    margin-top: -10%;
  }
}

.banner-img-mobile{
    width: 100% !important;
    margin: auto;
    // padding-left: 30%;
}

.under-banner-mobile{
 margin-top: 5%;
}

.casita-img{
  margin-right: 10px;
}

@media (max-width: 950px){
  .casita-img{
    margin-right: 10px;
    // margin-left: 6%;
}
}

@media (min-width: 1920px){
  .casita-img{
    margin-left: 18%;
}
}

.seguroHogar-text{
  font-size: 20px;
  color: rgba(0, 44, 119, 1);
}

.text-banner{
  font-size: 13px;
  color: #555555;
}

@media (min-width: 951px) and (max-width: 1200px){
  .text-banner{
    font-size: 10px;
    color: #555555;
  }
}

@media (max-width: 950px){
  .text-banner{
    font-size: 12px;
    color: 555555;

  }
}

.custom-checkbox {
  display: flex;
  align-items: flex-start; /* Usa 'center' si prefieres más alineado */
}

.custom-label {
  font-family: Helvetica, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 143.34%;
  letter-spacing: -0.3px;
  color: #232323;
  opacity: 0.8;
  text-align: justify;
  margin-top: 10%; /* Ajusta según sea necesario */
}

.titleLabel{
  display: flex; 
  text-align: flex-start; 
  margin-bottom: 3%; 
  color: #525252
}

.blackLetter{
  color: black;
  font-size: 16px;
}

.blackLetter2{
  color: black;
  font-size: 15px;
}



</style>